export default {
  hidden_rates:
    'Sommige betaalmethoden hebben ook een eigen tarief, ingesteld door de support van je platform. Die gelden in plaats van dit tarief.',
  title: 'Transactiekosten',
  subtitle:
    'De transactiekosten die {{company}} voor online betalingen worden berekend, ter dekking van de kosten van Stripe.',
  card_title: 'Transactiekosten',
  status: {
    inherited_tag: 'Partnerstandaard',
    inherited: 'Dit restaurant betaalt jouw standaard transactiekosten.',
    custom_tag: 'Aangepast',
    custom: 'Dit restaurant heeft eigen verwerkingskosten, die uw standaardtarief vervangen.',
    none_title: 'Geen transactiekosten ingesteld',
    none: 'Noch dit restaurant, noch je standaardinstelling heeft een tarief. Tenzij je op de partnerpagina voor verwerkingskosten een marge van 0% hebt bevestigd, kan het niet live gaan of online betalingen ontvangen; met die bevestiging worden er geen kosten in rekening gebracht en betaal jij de kosten van Stripe voor de betalingen.',
  },
  buttons: {
    set_custom: 'Eigen kosten instellen',
    edit: 'Bewerken',
    cancel: 'Annuleren',
    save: 'Opslaan',
    reset_to_default: 'Standaard herstellen',
  },
  toasts: {
    load_error: 'Kan de transactiekosten niet laden.',
    failed_to_save_changes: 'Kan de transactiekosten niet opslaan.',
    changes_got_saved: 'Transactiekosten opgeslagen',
    reset_to_default: 'Dit restaurant gebruikt nu jouw standaard transactiekosten.',
  },
};
